import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _SmartCollectFilledIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 9.00049C22.5523 9.00049 23 8.55277 23 8.00049V4.00049C23 2.34363 21.6569 1.00049 20 1.00049H16C15.4477 1.00049 15 1.4482 15 2.00049C15 2.55277 15.4477 3.00049 16 3.00049H20C20.5523 3.00049 21 3.4482 21 4.00049V8.00049C21 8.55277 21.4477 9.00049 22 9.00049ZM1 16.0005C1 15.4482 1.44772 15.0005 2 15.0005C2.55228 15.0005 3 15.4482 3 16.0005V20.0005C3 20.5528 3.44772 21.0005 4 21.0005H8C8.55228 21.0005 9 21.4482 9 22.0005C9 22.5528 8.55228 23.0005 8 23.0005H4C2.34315 23.0005 1 21.6573 1 20.0005V16.0005ZM23 16.0005C23 15.4482 22.5523 15.0005 22 15.0005C21.4477 15.0005 21 15.4482 21 16.0005V20.0005C21 20.5528 20.5523 21.0005 20 21.0005H16C15.4477 21.0005 15 21.4482 15 22.0005C15 22.5528 15.4477 23.0005 16 23.0005H20C21.6569 23.0005 23 21.6573 23 20.0005V16.0005ZM1 8.00049C1 8.55277 1.44772 9.00049 2 9.00049C2.55228 9.00049 3 8.55277 3 8.00049V4.00049C3 3.4482 3.44772 3.00049 4 3.00049H8C8.55228 3.00049 9 2.55277 9 2.00049C9 1.4482 8.55228 1.00049 8 1.00049H4C2.34315 1.00049 1 2.34363 1 4.00049V8.00049Z"
        fill={iconColor}
      />
      <Path
        d="M5.875 7.40674C5.875 6.44024 6.6585 5.65674 7.625 5.65674H16.375C17.3415 5.65674 18.125 6.44024 18.125 7.40674V10.688H5.875V7.40674Z"
        fill={iconColor}
      />
      <Path
        d="M18.3438 11.3442C18.7062 11.3442 19 11.6381 19 12.0005C19 12.3629 18.7062 12.6567 18.3438 12.6567H5.65625C5.29381 12.6567 5 12.3629 5 12.0005C5 11.6381 5.29381 11.3442 5.65625 11.3442H18.3438Z"
        fill={iconColor}
      />
      <Path
        d="M18.125 16.5942C18.125 17.5607 17.3415 18.3442 16.375 18.3442H7.625C6.6585 18.3442 5.875 17.5607 5.875 16.5942V13.313H18.125V16.5942Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const SmartCollectFilledIcon = assignWithoutSideEffects(_SmartCollectFilledIcon, {
  componentId: 'SmartCollectFilledIcon',
});

export default SmartCollectFilledIcon;
